import {
  shallowEqual,
  TypedUseSelectorHook,
  useDispatch,
  useSelector
} from 'react-redux';
import type { AppDispatch, RootState } from '@/store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

type AppSelector<TSelected> = (state: RootState) => TSelected;

export const useShallowAppSelector = <TSelected>(
  selector: AppSelector<TSelected>
) => useAppSelector(selector, shallowEqual);
